import React, { useEffect } from 'react'
import ReactPlayer from 'react-player/youtube'
import { func } from 'prop-types'
import styled from 'styled-components'
import { navigate } from '@reach/router'
import { EVENTOS_GA, URLS, PLANO_ANUAL } from '../../../../../constants'
import { useGlobal } from '../../../../../contexts/GlobalContext'
import Card from '@taglivros/oef_componentes/build/components/card'
import Button from '@taglivros/oef_componentes/build/components/button'
import StyleGuide from '@taglivros/oef_componentes/build/components/styleGuide'
import InlineLoader from '../../../../../components/InlineLoader/InlineLoader'
import {
  ICONS,
  TITULO_NOVIDADES_TAG,
  TITULO_BENEFICIOS,
  DESCRICAO_BENEFICIOS,
  BOTAO_PERMANECER,
  BOTAO_CANCELAR_ASSINATURA_MOBILE,
} from './constantsArgumentosProduto'
import { enviaEventoGA } from '../../../../../utils/helpers/helpersGA'
import { useModalidade } from '../../../../../contexts/ModalidadeContext'

const ArgumentosProdutoWrapper = styled.div`
  .card {
    @media(max-width: ${StyleGuide.mediaQuery.mobile}) {
      padding: 20px;
    }
  }
`

const ConteudoWrapper = styled.div`
  align-items: center;
  display: flex;
  flex-wrap: wrap;

  @media( max-width: ${StyleGuide.mediaQuery.mobile} ) {
    display: block;
  }

  .beneficios__wrapper {
    width: 36%;

    @media( max-width: ${StyleGuide.mediaQuery.mobile} ) {
      margin-bottom: 10px;
      width: 100%;
    }
  }

  .icons__wrapper {
    width: 64%;

    @media( max-width: ${StyleGuide.mediaQuery.mobile} ) {
      width: 100%;
    }

    ul {
      display: flex;
      flex-wrap: wrap;
    }

    li {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      width: 33.33%;

      figure {
        height: 132px;
        width: 132px;

        img {
          height: auto;
          max-width: 100%;
        }
      }

      @media( max-width: ${StyleGuide.mediaQuery.mobile} ) {
        width: 100%;

        p {
          margin-top: 5px;
          text-align: center;
          width: 100%;
        }

        figure {
          height: 122px;
          width: 122px;
        }
      }
    }
  }
`

const BotoesWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  margin: 50px 0;
  width: 100%;

  @media(max-width: ${StyleGuide.mediaQuery.mobile}) {
    margin: 30px 0 10px;
  }

  button {
    &:first-of-type {
      background-color:${StyleGuide.cores.branco};
      margin-right: 15px;
    }

    @media(max-width: ${StyleGuide.mediaQuery.mobile}) {
      font-size: 16px;

      &:first-of-type {
        margin: 0 auto 10px;
      }
    }
  }
`

const TituloNovidades = styled.h4`
  ${StyleGuide.tipografia.textoGrande}
  ${StyleGuide.boldFonte}
  margin-bottom: 30px;

  @media(max-width: ${StyleGuide.mediaQuery.mobile}) {
    margin-bottom: 15px;
  }
`

const ImagemWrapper = styled.div`
  align-items: center;
  background-color: ${StyleGuide.cores.branco};
  display: flex;
  justify-content: center;
  max-height: 385px;
  overflow: hidden;

  @media(max-width: ${StyleGuide.mediaQuery.mobile}) {
    max-height: inherit;
  }

  img {
    height: auto;
    max-width: 100%;

    @media( max-width: ${StyleGuide.mediaQuery.mobile} ) {
      max-width: inherit;
      width: 100%;
    }
  }
`

const VideoWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin: 0 auto;
  max-width: 100%;
`

const ArgumentosProduto = ( { onClickPermanecer } ) => {
  const { modalidadeURL, dadosStrapi, getDadosStrapi } = useGlobal()
  const { assinaturaPorModalidade } = useModalidade()

  useEffect( () => {
    getDadosStrapi()
  }, [] )

  const workflowAtivo = modalidadeURL === 'curadoria' ? 'retencao_curadoria' : 'retencao_ineditos'

  const banner = dadosStrapi?.data?.[ 0 ]?.Banners?.find( ( el ) => el.workflow === workflowAtivo )
  const youtubeVideoId = banner?.youtubeVideoId
  const urlVideo = youtubeVideoId ? `https://www.youtube.com/watch?v=${youtubeVideoId}` : null

  const handleContinuarSolicitacao = () => {
    let path = `${URLS.CANCELAR_ASSINATURA_SUSPENSAO}`

    if ( assinaturaPorModalidade.plano === PLANO_ANUAL.visualizacao ) {
      path = `${URLS.CANCELAR_ASSINATURA_AVISO_MULTA}`
    }

    navigate( `${path}` )
  }

  const imgAlt = 'Banner de próximo kit'
  return (
    <ArgumentosProdutoWrapper>
      <Card
        className="card"
        largura="100%"
      >
        <TituloNovidades>
          { TITULO_NOVIDADES_TAG }
        </TituloNovidades>

        { modalidadeURL && youtubeVideoId ?
          <VideoWrapper>
            <ReactPlayer
              controls={ true }
              height={ StyleGuide.isMobile() ? '198px' : '475px' }
              playing={ true }
              url={ urlVideo }
              width="100%"
            />
          </VideoWrapper> : null }

        { modalidadeURL && banner && !youtubeVideoId ?
          <ImagemWrapper>
            { !StyleGuide.isMobile() && banner.desktopImage ?
              <img
                alt={ banner.caption || imgAlt }
                src={ banner.desktopImage.url }
              /> : null}

            { StyleGuide.isMobile() && banner.mobileImage ?
              <img
                alt={ banner.caption || imgAlt }
                src={ banner.mobileImage.url }
              /> : null}
          </ImagemWrapper> : null }
      </Card>

      <Card
        className="card"
        margin="25px 0"
      >
        <ConteudoWrapper>
          <div className="beneficios__wrapper">
            <h2> { TITULO_BENEFICIOS } </h2>

            <p> { DESCRICAO_BENEFICIOS } </p>
          </div>

          <div className="icons__wrapper">
            <ul>
              { ICONS.map( ( item ) => (
                <li key={ item.titulo }>
                  <figure>
                    <img
                      alt={ item.titulo }
                      src={ item.icon }
                    />
                  </figure>

                  <p> { item.descricao } </p>
                </li>
              ) ) }
            </ul>
          </div>
        </ConteudoWrapper>
      </Card>

      <BotoesWrapper>
        <Button
          invertido
          onClick={ () => {
            enviaEventoGA( EVENTOS_GA.CANCELAMENTO.FLUXO, EVENTOS_GA.CANCELAMENTO.ACOES.PERMANECER )
            onClickPermanecer()
          } }
          tema={ Button.BOTAO_CURADORIA }
          type={ Button.TYPE_SUBMIT }
        >
          { BOTAO_PERMANECER }
        </Button>

        <Button
          className="button__cancelar"
          onClick={ () => {
            enviaEventoGA( EVENTOS_GA.CANCELAMENTO.FLUXO, EVENTOS_GA.CANCELAMENTO.ACOES.SEGUIR_CANCELAMENTO_SUSPENSAO )
            handleContinuarSolicitacao()
          } }
          tema={ Button.BOTAO_CURADORIA }
          testId="seguir-cancelamento"
        >
          { BOTAO_CANCELAR_ASSINATURA_MOBILE }
        </Button>
      </BotoesWrapper>
    </ArgumentosProdutoWrapper>
  )
}

ArgumentosProduto.propTypes = {
  'onClickPermanecer': func.isRequired
}

export default ArgumentosProduto

